module.exports = __webpack_public_path__ + "media/images/signatures/laci_signature_white-bb90ab6182ec49d9f5dbcf7f439bc789.png";